import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import Module      from '@dashboard/parts/projects/module';

// -------------------------------------------------------


class Guest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'active' // 'active' (進行中) または 'complete' (完了)
    };
  }

  render() {
    const { data } = this.props;
    const { activeTab } = this.state;
    const projects = data.projects || [];
    
    // 1. 進行中のプロジェクト: is_active_action＝1 OR (is_production＝1 & complete＝0)
    const activeProjects = projects.filter(d => {
    console.log(d);
      return d.is_active_action === 1 || (d.is_production === 1 && d.project_status != 'complete');
    });

    // 2. 完了したプロジェクト: (is_production＝0 OR complete＝1) & is_active_action＝0
    const completedProjects = projects.filter(d => {
      return (d.is_production === 0 || d.project_status == 'complete') && d.is_active_action === 0;
    });
    
    // 表示するプロジェクトをタブの状態によって切り替え
    const displayProjects = activeTab === 'active' ? activeProjects : completedProjects;

    return (
      <div className="projects">
        {/* CSS定義 */}
        <style>{`
          .project-tabs {
            display: flex;
            border-bottom: 2px solid #eee;
            margin-bottom: 20px;
          }
          .project-tab {
            padding: 12px 24px;
            cursor: pointer;
            font-weight: bold;
            color: #666;
            border-bottom: 3px solid transparent;
            transition: all 0.3s ease;
          }
          .project-tab:hover {
            color: #333;
            background-color: #f9f9f9;
          }
          .project-tab.active {
            color: #007bff;
            border-bottom-color: #007bff;
          }
          .tab-count {
            font-size: 0.8em;
            margin-left: 5px;
            background: #eee;
            padding: 2px 8px;
            border-radius: 10px;
            color: #333;
          }
          .project-title h2 {
            margin-bottom: 15px;
          }
        `}</style>

        <div className="project-title">
          <h2>プロジェクト</h2>
        </div>

        {/* タブメニュー */}
        <div className="project-tabs">
          <div 
            className={`project-tab ${activeTab === 'active' ? 'active' : ''}`}
            onClick={() => this.setState({ activeTab: 'active' })}
          >
            現在進行中のプロジェクト
            <span className="tab-count">{activeProjects.length}</span>
          </div>
          <div 
            className={`project-tab ${activeTab === 'complete' ? 'active' : ''}`}
            onClick={() => this.setState({ activeTab: 'complete' })}
          >
            完了したプロジェクト
            <span className="tab-count">{completedProjects.length}</span>
          </div>
        </div>
        
        {/* コンテンツ表示 */}
        {displayProjects.length > 0 ? (
          <Module data={data} projects={displayProjects} />
        ) : (
          <div style={{ padding: '40px', textAlign: 'center', color: '#999' }}>
            対象のプロジェクトはありません。
          </div>
        )}
      </div>
    );
  }
}

// -------------------------------------------------------

export default Guest;